<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CButton @click="collapse=!collapse" color="primary" class="mb-2">
                    فیلتر داده‌ها
                </CButton>
                <CCollapse :show="collapse" :duration="400">
                    <CCard>
                        <CCardHeader>
                            <strong>گزینه‌های فیلتر</strong>
                        </CCardHeader>
                        <CCardBody>
                            <CRow>
                                <CCol sm="3">
                                    <CInput v-model="form.name.val" :description="form.name.inv" label="نام" />
                                </CCol>
                                <CCol sm="3">
                                    <label>تاریخ ایجاد</label>
                                    <date-picker placeholder="انتخاب کنید" v-model="form.created_at.val"></date-picker>
                                    <small class="form-text text-muted w-100">{{form.created_at.inv}}</small>
                                </CCol>
                            </CRow>
                            <br>
                            <div class="form-group form-actions">
                                <CButton @click="validator();filter=true;page=1;get();" class="ml" color="primary">فیلتر</CButton>
                                <CButton @click="remove_filter" color="danger">حذف فیلتر</CButton>
                            </div>
                        </CCardBody>
                    </CCard>
                </CCollapse>
            </CCol>
            <CCol col="12" xl="12">
                <CCard>
                    <CCardHeader>
                        <strong>تعرفه‌ها</strong>
                        <div class="card-header-actions">
                            تعداد: {{row_count}}
                        </div>
                        </CCardHeader>
                    <CCardBody>
                        <CCol sm="5">
                            <CSelect v-model="limit" horizontal label="تعداد سطرها" :options="[
                                {value: 10}, {value: 20}, {value: 50}, {value: 100}]" class="row-count" placeholder="تعداد سطرها" @change="limit=$event.target.value" />
                        </CCol>
                        <CDataTable hover striped :items="items" :fields="fields" :noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }">
                            <template #action="data">
                                <td>
                                    <template>
                                    <div class="flex-container">
                                        <div v-show="$store.state.perms.can_view_mobile_operators_fee_info"
                                            @click="redirect_to(`/fee/${data.item.id}/details`)"
                                            v-c-tooltip.hover="'جزییات تعرفه'">
                                            <CIcon name="cilListRich" size="lg"/>
                                        </div>
                                        <div v-show="$store.state.perms.can_add_mobile_operators_fee_info"
                                            @click="redirect_to(`/fee/${data.item.id}/details/add`)"
                                            v-c-tooltip.hover="'افزودن جزییات'">
                                            <CIcon name="cilPlaylistAdd" size="lg"/>
                                        </div>
                                        <div v-show="$store.state.perms.can_update_mobile_operators_fee_info"
                                            @click="redirect_to(`/fee/${data.item.id}/edit`)"
                                            v-c-tooltip.hover="'ویرایش'">
                                            <CIcon name="cilPencil" size="lg"/>
                                        </div>
                                        <div v-show="$store.state.perms.can_delete_mobile_operators_fee_info"
                                            @click="delete_modal=true;id=data.item.id"
                                            v-c-tooltip.hover="'حذف'">
                                            <CIcon name="cilTrash" size="lg"/>
                                        </div>
                                    </div>
                                    </template>
                                </td>
                            </template>
                        </CDataTable>
                            <br>
                            <div> 
                                <CPagination
                                :activePage.sync="page"
                                :pages="page_count"
                                align="center"
                                :doubleArrows="true"
                                />
                            </div>
                        </CCardBody>
                </CCard>
            </CCol>
        </CRow>
        <CModal
            title="دقت کنید"
            size="sm"
            color="danger"
            :show.sync="delete_modal"
            >
            <p>آیا برای حذف شناسه {{id}} اطمینان دارید؟</p>
            <template #footer>
                <CButton @click="delete_modal=false" color="secondary">خیر</CButton>
                <CButton @click="delete_row" color="danger">بله</CButton>
            </template>
        </CModal>
    </div>
</template>
<script>
import validator from '../mixins'
export default {
    mixins: { validator },
    data () {
        return {
            row_count: '',
            items: [],
            fields: [
                { key: 'id', label: 'شناسه' },
                { key: 'name', label: 'نام' },
                { key: 'created_at', label: 'تاریخ ایجاد' },
                { key: 'action', label: 'عملیات' }
            ],
            collapse: false,
            form: {
                name: { val: '', inv: '', v: { max: 128 } },
                created_at: { val: '', inv: '', v: { max: 16 } },
            },
            filter: false,
            disable: false,
            page: 1,
            page_count: 0,
            offset: 0,
            limit: 10,
            delete_modal: false,
            id: 0,
        }
    },
    watch: {
        page: {
            handler(){
                this.get();
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        },
        limit: {
            handler() {
                this.page = 1;
                this.get();
            }
        }
    },
    mounted(){
        this.get();
    },
    methods: {
        get() {
            if (this.disable == false) {
                let filter = '';
                if(this.filter){
                    for (const key in this.form) {
                        if(this.form[key].val != ''){
                            if (key == 'created_at') {
                                filter += `&${key}=` + this.$moment(this.form[key].val, 'jYYYY-jMM-jDD').locale('es').format('YYYY-MM-DD');
                            } else {
                                filter += `&${key}=` + this.form[key].val;
                            }
                        }
                    }
                }
                this.axios.get('operators_fee/' 
                    + '?count=1' 
                    + filter)
                    .then(res => {
                        this.row_count = String(res.data.count).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        if(res.data.count > this.limit){
                            this.page_count = Math.ceil(res.data.count / this.limit);
                        } else {
                            this.page_count = 1;
                        }
                        this.offset = 0;
                        if(this.page != 1){
                            this.offset = (this.page * this.limit) - this.limit;
                        }
                    })
                .finally(() => {
                    this.axios.get('operators_fee/' 
                        + '?limit=' + this.limit 
                        + '&offset=' + this.offset 
                        + filter)
                        .then(res => {
                            res.data.map(val => {
                                val.created_at = this.$moment(val.created_at, 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD');
                            });
                            this.items = res.data;
                        })
                })
            }
        },
        remove_filter() {
            for (const key in this.form) {
                this.form[key].val = '';
                this.form[key].inv = '';
            }
            this.disable = false;
            this.filter = false;
            this.page = 1;
            this.get();
        },
        delete_row() {
			this.axios.delete('operators_fee/'
			+ this.id)
			.then(() => {
				this.$notify({
					group: 'foo',
					type: 'success',
					text: 'حذف با موفقیت انجام شد.'
                });
				this.delete_modal = false;
				this.get();
			})
			.catch(() => {
				this.$notify({
					group: 'foo',
					type: 'error',
					text: 'خطا! لطفا مجددا تلاش کنید.'
                });
                this.delete_modal = false;
			})
        },
        redirect_to(route) {
            this.$router.push(route);
        },
    },
    beforeCreate() {
        if (this.$store.state.perms.can_view_operator_fee_page == false
            && this.$store.state.verif == false) {
            this.$router.push('/403')
        }
    },
}
</script>
